module.exports = __webpack_public_path__ + "static/media/favedeal-icon.e9e167f5.svg";